import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      info: null
    };
  }
  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
      error: error,
      info: info
    });
  }
  render() {
    if (this.state.hasError) {
      return (
        <section className="padded card">
          <h1>Uh oh! We’re in trouble</h1>
          <p>Something’s come along and it’s burst our bubble</p>
        </section>
      );
    }
    return this.props.children;
  }
}
